import { t } from "ttag";

import { DocumentUploads } from "@/app/components/legacy-components";
import { DOCUMENT_FOLDER } from "@/shared/models/legacy-constants";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Dialog, StethoscopeIcon } from "@/shared/ui";

export const PrescriptionUploadsModal = ({ show, onClose }: ModalProps) => {
  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={StethoscopeIcon}>
          <Dialog.Title>{t`Add previous prescription`}</Dialog.Title>
        </Dialog.Header>

        <DocumentUploads
          folder={DOCUMENT_FOLDER.PRESCRIPTIONS}
          onCancel={onClose}
          onSuccess={onClose}
        />
      </Dialog.Content>
    </Dialog.Root>
  );
};
